import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Header from "../components/Header";
import noImage from "../assets/noImage.jpg";

const UniqueOrder = ({ order, setUniqueOrder }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const formatCurrency = (value) => {
    return `R$ ${value.toFixed(2).replace(".", ",")}`;
  };

  return (
    <Box m={2} mt={12} p={{ xs: 2, md: 10 }} bgcolor="white" borderRadius={3}>
      <Header category="Administrativo" title="Detalhamento de Pedido" />

      <Box display="flex" flexDirection="column" mb={2}>
        <Typography variant="h6" sx={{ textDecoration: "underline" }}>
          Compra em nome de <b>{order.user.name}</b>
        </Typography>
        {order.shippingTrack && (
          <Typography variant="subtitle1">
            Número para Rastreamento do Pedido no MR: {order.shippingTrack}
          </Typography>
        )}
      </Box>

      <Button
        variant="text"
        color="primary"
        sx={{ mb: 2 }}
        onClick={() => setUniqueOrder(null)}
      >
        voltar
      </Button>

      {/* Informações do Pedido */}
      <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Informações do Pedido:
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Typography>
              Número do Pedido: <strong>{order.orderCode.toUpperCase()}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Typography>
              Data do Pedido:{" "}
              <strong>{new Date(order.createdAt).toLocaleDateString()}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Typography>
              Tipo do Frete: <strong>{order.shippingMethod}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Typography>
              Valor do Frete:{" "}
              <strong>{formatCurrency(order.shippingPrice)}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2.4}>
            <Typography>
              Valor Total: <strong>{formatCurrency(order.total)}</strong>
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography>
              Status do Pedido: <strong>{gridOrderStatus(order)}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography>
              Status do Pagamento: <strong>{gridPaymentStatus(order)}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography>
              Forma de Pagamento: <strong>{paymentType(order)}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography>
              Status do Envio: <strong>{gridShipStatus(order)}</strong>
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      {/* Produtos + Endereço */}
      <Grid container spacing={2}>
        {/* Produtos */}
        <Grid item xs={12} md={7}>
          <Paper elevation={2} sx={{ p: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Produtos:
            </Typography>
            {order.items.map((item) => (
              <Box
                key={item.id}
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                alignItems="flex-start"
                borderBottom="1px solid #ddd"
                py={2}
              >
                <Box
                  flexShrink={0}
                  mr={2}
                  mb={{ xs: 1, sm: 0 }}
                  display="flex"
                  justifyContent="center"
                >
                  <img
                    src={item.imgUrl || noImage}
                    alt={item.name}
                    style={{ width: 120, height: 120, objectFit: "contain" }}
                  />
                </Box>
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {item.name}
                  </Typography>
                  <Typography>{formatCurrency(item.price)}</Typography>
                  <Typography>Qtd: {item.quantity}</Typography>
                  <Typography>
                    Subtotal: {formatCurrency(item.total)}
                  </Typography>
                  <Typography>{item.shortDesc}</Typography>
                </Box>
              </Box>
            ))}
          </Paper>
        </Grid>

        {/* Endereços */}
        <Grid item xs={12} md={5}>
          <Paper elevation={2} sx={{ p: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Informações de cobrança e entrega:
            </Typography>

            <Box bgcolor="#FAF9FB" borderRadius={1} p={2} mb={2}>
              <Typography fontWeight="bold">Endereço de Cobrança</Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Endereço:</strong> {order.orderBillingAddress.street},{" "}
                {order.orderBillingAddress.number}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Complemento:</strong>{" "}
                {order.orderBillingAddress.complement}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Bairro:</strong>{" "}
                {order.orderBillingAddress.neighborhood} -{" "}
                {order.orderBillingAddress.city} -{" "}
                {order.orderBillingAddress.state}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>País:</strong> {order.orderBillingAddress.country} -{" "}
                {order.orderBillingAddress.zipCode}
              </Typography>
            </Box>

            <Box bgcolor="#FAF9FB" borderRadius={1} p={2}>
              <Typography fontWeight="bold">Endereço de Entrega</Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Endereço:</strong> {order.orderShippingAddress.street},{" "}
                {order.orderShippingAddress.number}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Complemento:</strong>{" "}
                {order.orderShippingAddress.complement}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Bairro:</strong>{" "}
                {order.orderShippingAddress.neighborhood} -{" "}
                {order.orderShippingAddress.city} -{" "}
                {order.orderShippingAddress.state}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>País:</strong> {order.orderShippingAddress.country} -{" "}
                {order.orderShippingAddress.zipCode}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UniqueOrder;

const gridPaymentStatus = (status) => (
  <button
    type="button"
    style={{
      background:
        status.paymentStatus === "PENDING"
          ? "#FFC107"
          : status.paymentStatus === "PAYMENT_CREATED"
          ? "#007BFF"
          : status.paymentStatus === "PAYMENT_APPROVED_BY_RISK_ANALYSIS"
          ? "#28A745"
          : status.paymentStatus === "PAYMENT_REPROVED_BY_RISK_ANALYSIS"
          ? "#DC3545"
          : status.paymentStatus === "PAYMENT_UPDATED"
          ? "#007BFF"
          : status.paymentStatus === "PAYMENT_CONFIRMED"
          ? "#28A745"
          : status.paymentStatus === "PAYMENT_RECEIVED"
          ? "#28A745"
          : status.paymentStatus === "PAYMENT_CREDIT_CARD_CAPTURE_REFUSED"
          ? "#DC3545"
          : status.paymentStatus === "PAYMENT_ANTICIPATED"
          ? "#4C16E0"
          : status.paymentStatus === "PAYMENT_OVERDUE"
          ? "#DC3545"
          : status.paymentStatus === "PAYMENT_DELETED"
          ? "#DC3545"
          : status.paymentStatus === "PAYMENT_RESTORED"
          ? "#ECDD00"
          : status.paymentStatus === "PAYMENT_REFUNDED"
          ? "#DC3545"
          : status.paymentStatus === "PAYMENT_UPDATED"
          ? "#DC3545"
          : "#3D3D3D",
    }}
    className="text-black py-2 px-4 capitalize rounded-2xl text-md"
  >
    {status.paymentStatus === "PENDING"
      ? "Pendente"
      : status.paymentStatus === "PAYMENT_CREATED"
      ? "Criado"
      : status.paymentStatus === "PAYMENT_APPROVED_BY_RISK_ANALYSIS"
      ? "Aprovado pela Análise de Riscos"
      : status.paymentStatus === "PAYMENT_REPROVED_BY_RISK_ANALYSIS"
      ? "Reprovado pela Análise de Riscos"
      : status.paymentStatus === "PAYMENT_UPDATED"
      ? "Atualizado"
      : status.paymentStatus === "PAYMENT_CONFIRMED"
      ? "Confirmado"
      : status.paymentStatus === "PAYMENT_RECEIVED"
      ? "Recebido"
      : status.paymentStatus === "PAYMENT_CREDIT_CARD_CAPTURE_REFUSED"
      ? "Recusado pela Operadora do Cartão"
      : status.paymentStatus === "PAYMENT_ANTICIPATED"
      ? "Antecipado"
      : status.paymentStatus === "PAYMENT_OVERDUE"
      ? "Expirado"
      : status.paymentStatus === "PAYMENT_DELETED"
      ? "Deletado"
      : status.paymentStatus === "PAYMENT_RESTORED"
      ? "Restaurado"
      : status.paymentStatus === "PAYMENT_REFUNDED"
      ? "Extornado"
      : "Outros"}
  </button>
);

const gridOrderStatus = (props) => (
  <button
    type="button"
    style={{
      background:
        props.orderStatus === "CRIADO"
          ? "#B3B3B3"
          : props.orderStatus === "AGUARDANDO_PAGAMENTO"
          ? "#F2F20C"
          : props.orderStatus === "PROBLEMAS_PAGAMENTO"
          ? "#F3C211"
          : props.orderStatus === "PAGAMENTO_RECUSADO"
          ? "#FF4D4D"
          : props.orderStatus === "PAGAMENTO_REALIZADO"
          ? "#FFD400"
          : props.orderStatus === "EM_SEPARACAO"
          ? "#FFAA00"
          : props.orderStatus === "PEDIDO_SEPARADO"
          ? "#F28B24"
          : props.orderStatus === "AGUARDANDO_COLETA"
          ? "#F28B24"
          : props.orderStatus === "NOTA_FISCAL_EMITIDA"
          ? "#22C5E5"
          : props.orderStatus === "PEDIDO_DESPACHADO"
          ? "#2681FF"
          : props.orderStatus === "PEDIDO_ENTREGUE"
          ? "#3DCC6D"
          : props.orderStatus === "ORDEM_FINALIZADA"
          ? "#3DCC6D"
          : props.orderStatus === "ORDEM_CANCELADA"
          ? "#FF4D4D"
          : "#FF4D4D",
    }}
    className="text-[#000000] py-2 px-4 capitalize rounded-2xl text-md font-semibold"
  >
    {props.orderStatus === "CRIADO"
      ? "CRIADO"
      : props.orderStatus === "AGUARDANDO_PAGAMENTO"
      ? "AGUARDANDO PAGAMENTO"
      : props.orderStatus === "PROBLEMAS_PAGAMENTO"
      ? "PROBLEMAS COM PAGAMENTO"
      : props.orderStatus === "PAGAMENTO_RECUSADO"
      ? "PAGAMENTO RECUSADO"
      : props.orderStatus === "PAGAMENTO_REALIZADO"
      ? "PAGAMENTO REALIZADO"
      : props.orderStatus === "EM_SEPARACAO"
      ? "EM SEPRARAÇÃO"
      : props.orderStatus === "PEDIDO_SEPARADO"
      ? "PEDIDO SEPARADO"
      : props.orderStatus === "AGUARDANDO_COLETA"
      ? "AGUARDANDO COLETA"
      : props.orderStatus === "NOTA_FISCAL_EMITIDA"
      ? "NOTA FISCAL EMITIDA"
      : props.orderStatus === "PEDIDO_DESPACHADO"
      ? "PEDIDO DESPACHADO"
      : props.orderStatus === "PEDIDO_ENTREGUE"
      ? "PEDIDO ENTREGUE"
      : props.orderStatus === "ORDEM_FINALIZADA"
      ? "FINALIZADO"
      : props.orderStatus === "ORDEM_CANCELADA"
      ? "CANCELADO"
      : "OUTROS"}
  </button>
);

const gridShipStatus = (props) => (
  <button
    type="button"
    style={{
      background:
        props.shippingStatus === "PENDENTE"
          ? "#F2F20C"
          : props.shippingStatus === "EM_SEPARACAO"
          ? "#FFD400"
          : props.shippingStatus === "FRETE_COMPRADO"
          ? "#FFAA00"
          : props.shippingStatus === "AGUARDANDO_COLETA"
          ? "#F28B24"
          : props.shippingStatus === "COLETADO"
          ? "#A2C5E5"
          : props.shippingStatus === "EM_TRANSITO"
          ? "#22C5E5"
          : props.shippingStatus === "ENTREGUE"
          ? "#3DCC6D"
          : props.shippingStatus === "NAO_ENTREGUE"
          ? "#D941A6"
          : props.shippingStatus === "CANCELADO"
          ? "#FF4D4D"
          : "#FF4D4D",
    }}
    className="text-[#000000] py-2 px-4 capitalize rounded-2xl text-md"
  >
    {props.shippingStatus === "PENDENTE"
      ? "PENDENTE"
      : props.shippingStatus === "EM_SEPARACAO"
      ? "EM SEPARAÇÃO"
      : props.shippingStatus === "FRETE_COMPRADO"
      ? "FRETE COMPRADO"
      : props.shippingStatus === "AGUARDANDO_COLETA"
      ? "AGUARDANDO COLETA"
      : props.shippingStatus === "COLETADO"
      ? "COLETADO"
      : props.shippingStatus === "EM_TRANSITO"
      ? "EM TRÂNSITO"
      : props.shippingStatus === "ENTREGUE"
      ? "ENTREGUE"
      : props.shippingStatus === "NAO_ENTREGUE"
      ? "NÃO ENTREGUE"
      : props.shippingStatus === "CANCELADO"
      ? "CANCELADO"
      : "OUTROS"}
  </button>
);

const paymentType = (props) => (
  <button
    type="button"
    style={{
      background:
        props.paymentMethod === "CREDIT_CARD"
          ? "#22C5E5"
          : props.paymentMethod === "PIX"
          ? "#3DCC6D"
          : props.paymentMethod === "BANK_SLIP"
          ? "#D941A6"
          : "#FF4D4D",
    }}
    className="text-white py-1 px-2 capitalize rounded-2xl text-md"
  >
    {props.paymentMethod === "CREDIT_CARD"
      ? "CARTÃO DE CRÉDITO"
      : props.paymentMethod === "PIX"
      ? "PIX"
      : props.paymentMethod === "BANK_SLIP"
      ? "BOLETO"
      : "OUTROS"}
  </button>
);
